import React, { useEffect } from "react";

export default function AccelaCallbackBridge() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");

    if (window.opener && code) {
      window.opener.postMessage(
        {
          type: "ACCELA_AUTH",
          code,
          state,
        },
        window.location.origin
      );
    }

    window.close();
  }, []);

  return <div>Redirecting back to app...</div>;
}
